"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentUserOrgAdmin = exports.currentUserFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
const role_assignment_factory_1 = require("./role-assignment.factory");
exports.currentUserFactory = Factory.Sync.makeFactory({
    created_on: mocks_1.dates.date2000,
    external_identity_provider: false,
    first_name: mocks_1.persona.first_name,
    id: Factory.each(i => i + 1),
    last_name: mocks_1.persona.last_name,
    min_role_assignments: null,
    uri: Factory.each(i => `https://user.sportngin.com.dev/users/${i + 1}`),
    user_name: 'testuser',
    uuid: Factory.each(() => uuid_1.v4()),
});
exports.currentUserOrgAdmin = exports.currentUserFactory.extend({
    role_assignments: role_assignment_factory_1.roleAssignmentFactory.buildList(1)
});
